import * as tslib_1 from "tslib";
import { NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, ReplaySubject, fromEvent, merge, race, timer } from 'rxjs';
import { filter, map, mergeMap, repeat, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { ModalController } from '@ionic/angular';
import { DialogIdleLogoutComponent } from 'src/app/components/custom/dialog-idle-logout/dialog-idle-logout.component';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../auth/auth.service";
import * as i3 from "@ionic/angular";
const defaultIdleTimeMinutes = environment.production ? 15 : 1;
const defaultLogoutTimeMinutes = environment.production ? 25 : 2;
export class IdleLogoutService {
    constructor(router, auth, modalCtrl, _ngZone) {
        this.router = router;
        this.auth = auth;
        this.modalCtrl = modalCtrl;
        this._ngZone = _ngZone;
        this.stopped$ = new ReplaySubject(1);
        this.resetIdleTimer$ = new BehaviorSubject(null);
        this.idleCount = 0;
        this.idleCountBeforeLogout = 3;
        this.modalIsOpen = 0;
        // time in milliseconds until modal is opened (set in watch() for kiosk vs normal users)
        this.idleMilliseconds = defaultIdleTimeMinutes * 60000;
        // time in milliseconds, after modal is opened, until user is automatically logged out
        this.logoutMilliseconds = defaultLogoutTimeMinutes * 60000;
        this.idleTimeMinutes = defaultIdleTimeMinutes;
        this.logoutTimeMinutes = defaultLogoutTimeMinutes;
        this.interaction$ = merge(timer(0), this.resetIdleTimer$, fromEvent(window, 'mousemove'), fromEvent(window, 'keydown'), fromEvent(window, 'touchstart'), fromEvent(window, 'blur') // When user switches browser tab
        );
        // timer that resets on user interaction (before modal is opened)
        this.idle$ = this.interaction$.pipe(switchMap(() => timer(this.idleMilliseconds)));
        // timer that resets on user interaction (after modal is opened)
        this.delayLogout$ = this.interaction$.pipe(switchMap(() => timer(this.logoutMilliseconds)));
        // observable opens modal and emits when modal is closed or dismissed
        this.modal$ = timer(0).pipe(switchMap(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const modal = yield this.modalCtrl.create({
                component: DialogIdleLogoutComponent,
                componentProps: {
                    idleTime: this.idleTimeMinutes,
                    logoutTime: this.logoutTimeMinutes
                }
            });
            if (this.idleCount >= this.idleCountBeforeLogout) {
                debugger;
                console.log('Idle count limit reached... Logout! iLde Count: ', this.idleCount);
                this.resetIdleTimer$.next(null);
                this.idleCount = 0;
                this.auth.logout();
            }
            else {
                // Open the Model
                modal.present();
                this.modalIsOpen++;
                this.idleCount++;
                const { data, role } = yield modal.onWillDismiss();
                debugger;
                this.resetIdleTimer$.next(null);
                if (role === 'confirm') {
                    // console.log('The confirm button was clicked. Data: ', data)
                    this.modalIsOpen--;
                    this.idleCount = 0;
                    this.resetIdleTimer$.next(null);
                }
            }
            return merge(modal.onWillDismiss()).pipe(tap(() => {
                debugger;
                this.modalIsOpen--;
                this.resetIdleTimer$.next(null);
            }));
        })));
        this.idle$.subscribe(idle => {
            console.log('idle$ subscription: ', idle);
            console.log('idle$ idleTime: ', this.idleTimeMinutes, ', idleMilliseconds: ', this.idleMilliseconds);
            console.log('idle$ logoutTime: ', this.logoutTimeMinutes, ', logoutMilliseconds:', this.logoutMilliseconds);
        });
    }
    /**
     * Enables auto logout on a component
     */
    watch() {
        const isKiosk = this.auth.hasDepotKioskPermission();
        if (isKiosk) {
            this.idleTimeMinutes = environment.production ? 60 : 30; // 60 or 30 min until warning
            this.logoutTimeMinutes = environment.production ? 120 : 60; // 120 or 60 min until auto logout
        }
        else {
            this.idleTimeMinutes = defaultIdleTimeMinutes;
            this.logoutTimeMinutes = defaultLogoutTimeMinutes;
        }
        this.idleMilliseconds = this.idleTimeMinutes * 60000;
        this.logoutMilliseconds = this.logoutTimeMinutes * 60000;
        this._ngZone.runOutsideAngular(() => {
            this.idle$.pipe(filter(() => !this.modalIsOpen), mergeMap(() => race(this.delayLogout$.pipe(map(() => true)), this.modal$.pipe(map(() => false)))), filter(result => result), take(1), takeUntil(this.stopped$), repeat())
                .subscribe(() => {
                // Refresh the user's token when the logout timeout is reached (keeps session alive if they come back)
                this.auth.userRefreshToken().catch(() => { });
                this.resetIdleTimer();
                // console.log('Logout timeout has been reached.  this.delayLogout$: ',  this.delayLogout$)
                // console.log('Logout timeout has been reached.  this.modal$: ',  this.modal$)
                // console.log('Logout timeout has been reached.  environment:  ',  environment.production);
            });
        });
    }
    /**
     * Call on ngOnDestroy() to prevent behavior from carrying over after component destroyed
     */
    stop() {
        this.stopped$.next(true);
        this.stopped$.complete();
        this.unsubscribeObservable();
        this.idleCount = 0;
    }
    resetIdleTimer() {
        // console.log('resetIdleTimer: ', this.idle$);
        this.resetIdleTimer$.next(null);
    }
    subscribeObservable() {
        this.idleSubscription = this.idle$.subscribe((x) => {
            console.log(`idleSubscription subcribed for ${x + 1} sec`);
        });
        this.logoutSubscription = this.delayLogout$.subscribe((x) => {
            console.log(`logoutSubscription subcribed for ${x + 1} sec`);
        });
    }
    unsubscribeObservable() {
        console.log('  unsubscriebd');
        if (this.idleSubscription) {
            this.idleSubscription.unsubscribe();
        }
        if (this.logoutSubscription) {
            this.logoutSubscription.unsubscribe();
        }
    }
}
IdleLogoutService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IdleLogoutService_Factory() { return new IdleLogoutService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.AuthService), i0.ɵɵinject(i3.ModalController), i0.ɵɵinject(i0.NgZone)); }, token: IdleLogoutService, providedIn: "root" });
